import Dialog from "../../dialog/Dialog";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { listAllPackages } from "./packageService";
import { useQuery } from "@tanstack/react-query";
import { formatListingDateTime } from "../../../utils/formatListingDate";

function SubPackages({ open, onClose, packageGroupId }) {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [groupName, setGroupName] = useState("");

  const {
    data: packages,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["packages", packageGroupId],
    queryFn: () => listAllPackages(),
  });

  const viewHandler = (id) => {
    onClose();
    navigate(`/packages/${id}/edit`);
  };

  useEffect(() => {
    if (packages?.data?.data) {
      // Filter packages based on package_group_id
      const filteredPackages = packages.data.data.filter(
        (pkg) => pkg.package_group_id === packageGroupId
      );
      setData(filteredPackages);
      
      // Find the package group name from any package in the group
      const packageGroup = packages.data.data.find(
        (pkg) => pkg.package_group_id === packageGroupId
      );
      if (packageGroup) {
        setGroupName(packageGroup.name || "");
      }
    }
  }, [packages, packageGroupId]);

  const handleClose = () => {
    onClose();
  };

  const handleNameChange = (e) => {
    setGroupName(e.target.value);
    // You can add API call here or debounce it
    // updatePackageGroupName(packageGroupId, e.target.value);
  };

  return (
    <Dialog open={open} onClose={handleClose} title="Package Details">
      <div className="p-4">
        {isLoading && <div>Loading...</div>}
        {error && <div>Error: {error.message}</div>}

        <div className="overflow-x-auto">
          {/* Group Name Input */}
          <div className="mb-6">
            <label htmlFor="groupName" className="block text-sm font-medium text-gray-700 mb-1">
              Package Name
            </label>
            <input
              id="groupName"
              type="text"
              value={groupName}
              onChange={handleNameChange}
              className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-[#845EC5] focus:border-[#845EC5] text-sm"
              placeholder="Enter package name"
            />
          </div>

          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-500 capitalize">
                  Package ID
                </th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-500 capitalize">
                  Tour Type
                </th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-500 capitalize">
                  Created Date
                </th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-500 capitalize">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {data.map((pkg) => (
                <tr key={pkg.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2 text-sm text-gray-800">{pkg.package_uid}</td>
                  <td className="px-4 py-2 text-sm text-gray-800">
                    {pkg.tour_type}
                  </td>
                  <td className="px-4 py-2 text-sm text-gray-800">
                    {formatListingDateTime(pkg.created_at_formatted || pkg.created_at)}
                  </td>
                  <td className="px-4 py-2 text-sm text-gray-800">
                    <button
                      onClick={() => viewHandler(pkg.id)}
                      className="text-[#845EC5] hover:text-[#845EC5] border border-gray-200 hover:border-[#845EC5] bg-gray-50 p-1 rounded mr-2"
                    >
                      <i className="fi fi-rr-pencil flex items-center justify-center"></i>
                    </button>
                    <button className="text-[#FF0004] hover:text-[#FF0004] border border-gray-200 hover:border-[#FF0004] bg-gray-50 p-1 rounded">
                      <i className="fi fi-rr-trash flex items-center justify-center"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Dialog>
  );
}

export default SubPackages;
